const discountMonthly = 5;
const discount3Months = 15;

jQuery(document).ready(function () {
    
  
    jQuery.each(jQuery(".testKey"), function (i, ele) {
        if (localStorage.testKey) {
            jQuery(ele).val(localStorage.testKey);
        }
    });

    var isMobile = window.navigator.userAgent.match(
        /(iPhone|iPod|iPad|Android|webOS|BlackBerry|IEMobile|Opera Mini)/i
    );
    // // console.log("Is Mobile: " + !!isMobile);

    //Load Video only on non-mobile
    if (!isMobile) {
        var video = document.querySelector("#LoadVideo");
        if (video) {
            video.src =
                "https://cdn.shopify.com/videos/c/o/v/e36e3a73dcd44b71b595d269d790ae70.mp4";
            video.play();
        }
    }

    if (window.location.href.indexOf("cart") > -1) {
        if (
            jQuery("body").find(".zq-cart-cartcontents--recommended-list").length >
            0 &&
            jQuery("body").find(".zq-cart-cartcontents--others-list").length > 0
        ) {
            jQuery(".quiz_link").css("display", "none");
            jQuery(".checkout_link").css("display", "block");

            jQuery(".zq-cart-banner-button").css("display", "none");
        } else {
            jQuery(".quiz_link").css("display", "block");
            jQuery(".checkout_link").css("display", "none");
        }
        if (
            localStorage.getItem("ZitamineQuiz") !== null &&
            JSON.parse(localStorage.getItem("ZitamineQuiz")).quizResults != null
        ) {
            storageData = JSON.parse(localStorage.ZitamineQuiz);
            jQuery("#quiz_name").val(storageData.firstName);
            jQuery("#testKey").val(localStorage.testKey);

            jQuery("#quiz_user").text(storageData.firstName);

            if (storageData.quizResults) {
                jQuery(".cart-recommendation-button").css("display", "none");
            } else {
                jQuery(".cart-recommendation-button").css("display", "block");
            }
            var url_string = window.location.href;
            if (url_string.includes("utm")) {
                localStorage.setItem("utmUrl", url_string);
            }
        } else {
            jQuery(".existing_recommendation_block").css("display", "none");
        }
    }

    $(function () {
        $.fn.scrollBottom = function () {
            return $(document).height() - this.scrollTop() - this.height();
        };
        var $el = $(".desktopcartcontents");
        var $window = $(window);
        $window.bind("scroll resize", function () {
            var gap = $window.height() - $el.height() - 10;
            var visibleFoot = 467 - $window.scrollBottom();
            var scrollTop = $window.scrollTop();
            if (scrollTop < 120 + 10) {
                $el.css({
                    top: 120 - scrollTop + "px",
                    bottom: "auto",
                });
            } else if (visibleFoot > gap) {
                $el.css({
                    top: "auto",
                    bottom: visibleFoot + "px",
                });
            } else {
                $el.css({
                    top: 10,
                    bottom: "auto",
                });
            }
        });
    });

    if (window.matchMedia("(max-width: 767px)").matches) {
        var menu = jQuery("#cart_button");
        function isInViewport(scroll) {
            var viewportTop = jQuery(".order_sale").offset().top - 100;
            var viewportBottom = viewportTop + jQuery(".order_sale").height();
            // // console.log(scroll+'  --  '+viewportTop);
            if (scroll > viewportTop) {
                menu.addClass("scrollorder");
            } else {
                menu.removeClass("scrollorder");
            }
        }

        //jQuery(window).scroll(function () {
      //      var scroll = jQuery(window).scrollTop();
      //      isInViewport(scroll);
      //  });
    }

    jQuery("input").click(function () {
        jQuery("input:not(:checked)").parent().parent().removeClass("active");
        jQuery("input:checked").parent().parent().addClass("active");
    });

    setTimeout(function () {
        let total = updateTotal();

        if ((total[0] && total[1]) || (total[0] && total[2]) || (total[1] && total[2])) {
            jQuery(".mobilecartcontents #selling_plan_discounted").click();
        }

        var cartStorage = new ZitamineData("ZitamineQuiz", true);
        var cartResults = cartStorage.quizResults;
        if (cartResults) {
            if (
                cartResults.MonthlyRecommendations &&
                cartResults.MonthlyRecommendations[0]
            ) {
                var productRecommendations =
                    cartResults.MonthlyRecommendations[0].Recommendations;
            } else {
                var productRecommendations = [];
            }
        } else {
            var productRecommendations = [];
        }
        jQuery.getJSON("/cart.js", function (cart, textStatus) {
            if (productRecommendations.length > 0 && cart.item_count > 0) {
                jQuery("body").addClass("hasrecomm-hascart");
            } else if (productRecommendations.length > 0 && cart.item_count == 0) {
                jQuery("body").addClass("hasrecomm-nocart");
                AddItemName();
            } else if (productRecommendations.length == 0 && cart.item_count > 0) {
                jQuery("body").addClass("norecomm-hascart");
            } else {
                jQuery("body").addClass("norecomm-nocart");
                AddStaticName();
            }
        });
    }, 1000);

    ToggleGiftCardOptions();

    try {
        setTimeout(() => {
            ChangeSellingPlan();
        }, 1500);
    } catch (error) {
        console.log(error);
    }

    makeCheckboxRequired();
});

function makeCheckboxRequired() {
    const registerForm = $("#create_customer");
    const createButton = registerForm.find(".button.button--primary");
    const checkbox = registerForm.find("#RegisterForm-Agree2");
    const checkboxError = $("#terms-condition-checkbox");

    // checkbox.on("change", function () {
    //     if (checkbox.is(":checked")) {
    //         createButton.prop("disabled", false);
    //     } else {
    //         createButton.prop("disabled", true);
    //     }
    // });

    registerForm.on("submit", function (event) {
        // Check if the checkbox is checked
        if (!checkbox.is(":checked")) {
            event.preventDefault();
            checkboxError.show();
            return;
        }

        checkboxError.hide();
    });

}

function ToggleGiftCardOptions() {
    if ($(".gift-product-card").length > 0) {
    }
}

function ChangeSellingPlan(runAgain = false) {
    // get elements with class "appstle_subscription_radio_wrapper"
    let elements = document.querySelectorAll(".appstle_subscription_radio_wrapper");

    if (!elements && !runAgain) {
        setTimeout(() => {
            ChangeSellingPlan(true);
        }, 1000);
    } else {
        for (let i = 0; i < elements.length; i++) {
            // get radio input inside with name="selling_plan"

            let radio = elements[i].querySelector('input[name="selling_plan"]');

            // change it's value to 3581018330
            if (radio) {
                radio.value = '';
            }

        }
    }
}

async function clearCartFromSwitch(id = false) {
    jQuery(".cart-loader-center").show();

    try {
        // Await the AJAX call to complete
        await jQuery.ajax({
            type: "POST",
            url: "/cart/clear.js",
            data: "",
            dataType: "json",
        });


        // If the AJAX call is successful, this line will be executed
        await addItemAgain(id);
    } catch (error) {
        // Handle any errors here
        console.error("Error clearing cart:", error);
    } finally {
        // You can perform any cleanup actions here if necessary
        jQuery(".cart-loader-center").hide(); // For example, hiding the loader
        // // console.log("Action done");
    }
}
function AddStaticName() {
    let itemsExtra = "<div class='productRecommendations'>";
    itemsExtra +=
        "<div class='recommendate_product_list'><div class='recommendate_product_list_onclick' onclick='addThisTocart(this)' selling-plan='' data-id='42101584199898'>+</div><div class='recommendate_product_list_sku'>Vitamina D3 2000 UI</div><div class='recommendate_product_list_price'>23 Lei</div></div>";
    itemsExtra +=
        "<div class='recommendate_product_list'><div class='recommendate_product_list_onclick' onclick='addThisTocart(this)' selling-plan='' data-id='42295045423322'>+</div><div class='recommendate_product_list_sku'>Magneziu pentru stres și inimă</div><div class='recommendate_product_list_price'>18 Lei</div></div>";
    itemsExtra +=
        "<div class='recommendate_product_list'><div class='recommendate_product_list_onclick' onclick='addThisTocart(this)' selling-plan='' data-id='42560871301338'>+</div><div class='recommendate_product_list_sku'>Ashwagandha</div><div class='recommendate_product_list_price'>31 Lei</div></div>";
    itemsExtra +=
        "<div class='recommendate_product_list'><div class='recommendate_product_list_onclick' onclick='addThisTocart(this)' selling-plan='' data-id='42415753232602'>+</div><div class='recommendate_product_list_sku'>Curcumin natural</div><div class='recommendate_product_list_price'>44 Lei</div></div>";
    itemsExtra += "</div>";
    $(".zq-cart-cartcontents--content").append(itemsExtra);
}
function AddItemName() {
    var cartStorage = new ZitamineData("ZitamineQuiz", true);
    var cartResults = cartStorage.quizResults;
    var productRecommendations =
        cartResults.MonthlyRecommendations[0].Recommendations;
    getidFromSku().then((skus) => {
        let itemsExtra = "<div class='productRecommendations'>";
        for (const product of productRecommendations) {
          console.log("asdasd vlad asd");
          console.log(product);
            itemsExtra +=
                "<div class='recommendate_product_list'><div class='recommendate_product_list_onclick' onclick='addThisTocart(this)' selling-plan='" +
                skus[product.ProductCode].selling_plan_id +
                "' data-id='" +
                skus[product.ProductCode].variant_id +
                "'>+</div><div class='recommendate_product_list_sku'>" +
                skus[product.ProductCode].title +
                "</div><div class='recommendate_product_list_price'>" +
                skus[product.ProductCode].price +
                "Lei</div></div>";
        }
        itemsExtra += "</div>";
        $(".zq-cart-cartcontents--content").append(itemsExtra);
    });
}
function addThisTocart(el) {
    let sellingPlan = jQuery(el).attr("selling-plan");
    let variantId = jQuery(el).attr("data-id");
    const items = [];
    const item = {
        id: variantId,
        quantity: 1,
        properties: {
            Recomandate: "da",
        },
        selling_plan: sellingPlan,
    };
    items.push(item);
    addItemNew(items);
}
function AddItem() {
    var cartStorage = new ZitamineData("ZitamineQuiz", true);
    var cartResults = cartStorage.quizResults;
    var productRecommendations =
        cartResults.MonthlyRecommendations[0].Recommendations;
    jQuery(".cart-loader-center").show();
    jQuery.ajax({
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        dataType: "json",
        success: function () {
            getidFromSku().then((skus) => {
                const items = [];
                for (const product of productRecommendations) {
                    const item = {
                        id: skus[product.ProductCode].variant_id,
                        quantity: product.Quantity,
                        properties: {
                            Recomandate: "da",
                        },
                        selling_plan: '',
                    };
                    items.push(item);
                }
                addItemNew(items);
            });
        },
        error: function (XMLHttpRequest, textStatus) { },
    });
}
async function addItemNew(items) {
    items.reverse();
    const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: items }),
    });
    if (response.status == 200) {
        window.zqc.renderCartContents();
        const json = await response.json();
        // // console.log("after addItemNew: ");
        // // console.log(json.items);
        window.cart_data.items = json.items;
        jQuery(".cart-loader-center").hide();
        loadSliderJs();
    }
}
async function addItemAgain(id = false) {
    let itemList = [];
    let cartProducts = jQuery(
        ".desktopcartcontents .zq-cart-cartcontents--product"
    );
    jQuery.each(cartProducts, function (i, ele) {
        let itemKey = jQuery(ele).attr("data-line-item-key");
        itemKey = itemKey.split(":");
        let variantId = itemKey[0];
        let quantity = jQuery(ele).attr("data-line-item-qty");
        let existingItem = itemList.find((x) => x.id == variantId);
        let item = null;
        if (id) {
            item = {
                id: variantId,
                quantity: quantity,
                selling_plan: id,
            };
            itemList.push(item);
        } else {
            item = {
                id: variantId,
                quantity: quantity,
            };
            itemList.push(item);
        }
    });
    itemList.reverse();


    const response = await fetch("/cart/add.js", {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({ items: itemList }),
    });

    if (response.status == 200) {
        window.zqc.renderCartContents();
        const json = await response.json();
        // // console.log("after addItemAgain: ");
        // // console.log(json.items);
        window.cart_data.items = json.items;
        jQuery(".cart-loader-center").hide();
        loadSliderJs();
    }
}
function updateTotal() {
    let orgPrice = 0;
    let discountedPrice = 0;
    let discounted = 0;
    let discounted3MonthsCount = 0;
    let nondiscounted = 0;
    let discounted3Months = 0;

    // console.log("Before step 4");

    if (
        typeof window.cart_data !== "undefined" &&
        window.cart_data.items &&
        window.cart_data.items.length
    ) {
        for (let index = 0; index < window.cart_data.items.length; index++) {
            const element = window.cart_data.items[index];

            let qty = $(".desktopcartcontents")
                .find("[data-line-item-key='" + element.key + "']")
                .attr("data-line-item-qty");

            qty = element.quantity;

            if (!qty) {
                continue;
            }

            if (element.selling_plan_allocation &&
                element.selling_plan_allocation.selling_plan.id &&
                element.selling_plan_allocation.selling_plan.id != 3581018330) {
                discounted3Months = true;

                discounted3MonthsCount++;
                jQuery(".mobilecartcontents #selling_plan_discounted_3_months").attr(
                    "checked",
                    "checked"
                );
                jQuery(".mobilecartcontents #selling_plan_discounted_3_months")
                    .parent()
                    .parent()
                    .addClass("active");
                jQuery(".mobilecartcontents #selling_plan_nondiscounted")
                    .parent()
                    .parent()
                    .removeClass("active");
                jQuery(".mobilecartcontents #selling_plan_discounted")
                    .parent()
                    .parent()
                    .removeClass("active");

                orgPrice +=
                    parseFloat(element.selling_plan_allocation.compare_at_price) * qty / 3;
                discountedPrice +=
                    parseFloat(element.selling_plan_allocation.compare_at_price) * qty * (1 - discountMonthly / 100) / 3;
                discounted3Months += parseFloat(element.selling_plan_allocation.price) * qty;

                // console.log(element.selling_plan_allocation.price);
                // console.log(element.selling_plan_allocation.compare_at_price);

                jQuery(".desktopcartcontents #selling_plan_discounted_3_months").attr(
                    "checked",
                    "checked"
                );
                jQuery(".desktopcartcontents #selling_plan_discounted_3_months")
                    .parent()
                    .parent()
                    .addClass("active");
                jQuery(".desktopcartcontents #selling_plan_discounted")
                    .parent()
                    .parent()
                    .removeClass("active");
                jQuery(".desktopcartcontents #selling_plan_nondiscounted")
                    .parent()
                    .parent()
                    .removeClass("active");

            } else if (
                element.selling_plan_allocation &&
                element.selling_plan_allocation.selling_plan.id &&
                element.selling_plan_allocation.selling_plan.id == 3581018330
            ) {
                discounted++;
                jQuery(".mobilecartcontents #selling_plan_discounted").attr(
                    "checked",
                    "checked"
                );
                jQuery(".mobilecartcontents #selling_plan_discounted")
                    .parent()
                    .parent()
                    .addClass("active");
                jQuery(".mobilecartcontents #selling_plan_discounted_3_months")
                    .parent()
                    .parent()
                    .removeClass("active");
                jQuery(".mobilecartcontents #selling_plan_nondiscounted")
                    .parent()
                    .parent()
                    .removeClass("active");

                orgPrice +=
                    parseFloat(element.selling_plan_allocation.compare_at_price) * qty;
                discountedPrice +=
                    parseFloat(element.selling_plan_allocation.price) * qty;
                discounted3Months += parseFloat(element.selling_plan_allocation.compare_at_price) * qty * 3 * (1 - discount3Months / 100);


                jQuery(".desktopcartcontents #selling_plan_discounted").attr(
                    "checked",
                    "checked"
                );
                jQuery(".desktopcartcontents #selling_plan_discounted")
                    .parent()
                    .parent()
                    .addClass("active");
                jQuery(".desktopcartcontents #selling_plan_discounted_3_months")
                    .parent()
                    .parent()
                    .removeClass("active");
                jQuery(".desktopcartcontents #selling_plan_nondiscounted")
                    .parent()
                    .parent()
                    .removeClass("active");
            } else {
                nondiscounted++;
                jQuery(".mobilecartcontents #selling_plan_nondiscounted").attr(
                    "checked",
                    "checked"
                );
                jQuery(".mobilecartcontents #selling_plan_discounted")
                    .parent()
                    .parent()
                    .removeClass("active");
                jQuery(".mobilecartcontents #selling_plan_discounted_3_months")
                    .parent()
                    .parent()
                    .removeClass("active");
                jQuery(".mobilecartcontents #selling_plan_nondiscounted")
                    .parent()
                    .parent()
                    .addClass("active");

                jQuery(".desktopcartcontents #selling_plan_nondiscounted").attr(
                    "checked",
                    "checked"
                );
                jQuery(".desktopcartcontents #selling_plan_discounted")
                    .parent()
                    .parent()
                    .removeClass("active");
                jQuery(".desktopcartcontents #selling_plan_discounted_3_months")
                    .parent()
                    .parent()
                    .removeClass("active");
                jQuery(".desktopcartcontents #selling_plan_nondiscounted")
                    .parent()
                    .parent()
                    .addClass("active");
                orgPrice += parseFloat(element.final_price) * qty;
                discountedPrice +=
                    parseFloat(
                        parseFloat(element.final_price) -
                        parseFloat(element.final_price) * (discountMonthly / 100)
                    ) * qty;
                discounted3Months += parseFloat(element.final_price) * qty * 3 * (1 - discount3Months / 100);

            }
        }
    }
    orgPrice = orgPrice / 100;
    discountedPrice = discountedPrice / 100;
    discounted3Months = discounted3Months / 100;

    jQuery(".mobilecartcontents .with_discount h4").html(
        discountedPrice.toFixed(0) +
        " Lei<span>" +
        (discountedPrice / 30).toFixed(2) +
        " Lei/zi"
    );
    jQuery(".desktopcartcontents .with_discount h4").html(
        discountedPrice.toFixed(0) +
        " Lei<span>" +
        (discountedPrice / 30).toFixed(2) +
        " Lei/zi"
    );

    jQuery(".mobilecartcontents .with_discount_3_months h4").html(
        (orgPrice * 3 * (1 - discount3Months / 100)).toFixed(0) +
        " Lei<span>" +
        ((orgPrice * 3 * (1 - discount3Months / 100)) / 90).toFixed(2) +
        " Lei/zi"
    );
    jQuery(".desktopcartcontents .with_discount_3_months h4").html(
        (orgPrice * 3 * (1 - discount3Months / 100)).toFixed(0) +
        " Lei<span>" +
        ((orgPrice * 3 * (1 - discount3Months / 100)) / 90).toFixed(2) +
        " Lei/zi"
    );


    jQuery(".mobilecartcontents .without_discount h4").html(
        orgPrice.toFixed(0) + " Lei<span>" + (orgPrice / 30).toFixed(2) + " Lei/zi"
    );
    jQuery(".desktopcartcontents .without_discount h4").html(
        orgPrice.toFixed(0) + " Lei<span>" + (orgPrice / 30).toFixed(2) + " Lei/zi"
    );
    return [discounted, nondiscounted, discounted3MonthsCount];
}
async function getidFromSku() {
    const response = await fetch("/collections/all?view=zitamine-quiz-skus-json");
    const json = await response.json();
    return json;
}
function loadSliderJs() {
    jQuery("#cart_slider_first_block").addClass("loader");
    jQuery("#cart_slider_first_block").load(
        location.href + " #cart_slider_first_block>*",
        ""
    );
    setTimeout(function () {
        jQuery(".cart-slider").owlCarousel({
            loop: false,
            margin: 30,
            nav: true,
            autoplaySpeed: 1200,
            smartSpeed: 1200,
            responsiveClass: true,
            responsive: {
                0: {
                    items: 1,
                    stagePadding: 10,
                    margin: 0,
                },
                600: {
                    items: 2,
                },
                1000: {
                    items: 2,
                },
                1366: {
                    items: 2,
                },
            },
        });
        jQuery("#cart_slider_first_block").removeClass("loader");
    }, 2000);
}
/* FROM ZitamineQuiz.js */

class ZitamineCommon {
    #productSKUTable = null;
    #productSKUTableIsLoading = false;

    handle(str) {
        return str
            .replace(/^[A-Z]/g, (str) => str.toLowerCase())
            .replace(/[A-Z][a-z]/g, (str) => "-" + str.toLowerCase())
            .replace(/A\-/g, (str) => "-" + str.toLowerCase())
            .replace(/\W+/g, "-");
    }

    dataAttributeNameToDatasetPropertyName(str) {
        return str.replace(/^data-/g, "").replace(/-([a-z])/g, (str) => {
            return str[1].toUpperCase();
        });
    }

    async fetchAllProductTitleTable() {
        const response = await fetch(
            "/collections/all?view=zitamine-quiz-products-json"
        );
        const json = await response.json();
        return json;
    }

    async sleep(ms) {
        return new Promise((resolve) => setTimeout(resolve, ms));
    }

    async fetchAllProductSKUTable() {
        while (this.#productSKUTableIsLoading) {
            await this.sleep(100);
        }
        if (this.#productSKUTable !== null) return this.#productSKUTable;

        this.#productSKUTableIsLoading = true;

        const response = await fetch(
            "/collections/all?view=zitamine-quiz-skus-json"
        );
        const json = await response.json();
        this.#productSKUTable = json;

        this.#productSKUTableIsLoading = false;
        return json;
    }

    async shopifyCartAdd(itemList) {
      itemList = itemList.filter((item) => item.id !== undefined);
      
        const response = await fetch("/cart/add.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify({ items: itemList }),
        });
        const json = await response.json();
        return json;
    }
}

class ZitamineData {
    #key = undefined;
    #quizResults = null;
    #emailAddress = null;
    #firstName = null;
    #profile = null;
    #utm = null;
    #storage = undefined;
    #data = null;

    constructor(key, save_across_sessions = false) {
        this.#key = key;

        if (save_across_sessions) {
            this.#storage = localStorage;
        } else {
            this.#storage = sessionStorage;
        }
        this.loadFromStorage();
        let searchParams = new URLSearchParams(window.location.search);
        // // console.log(searchParams);
        if (searchParams.has("utm")) {
            let utm = searchParams.get("utm");
            this.#utm = utm;
            this.saveToStorage();
            localStorage.setItem("utmUrl", utm);
        }
    }

    get emailAddress() {
        return this.#emailAddress;
    }

    set emailAddress(value) {
        this.#emailAddress = value;
        this.saveToStorage();
    }

    get quizResults() {
        return this.#quizResults;
    }

    set quizResults(value) {
        this.#quizResults = value;
        this.saveToStorage();
    }

    get firstName() {
        return this.#firstName;
    }

    get profile() {
        return this.#profile;
    }

    set firstName(value) {
        this.#firstName = value;
        this.saveToStorage();
    }

    set profile(value) {
        this.#profile = value;
        this.saveToStorage();
    }

    get utm() {
        return this.#utm;
    }

    set utm(value) {
        this.#utm = value;
        this.saveToStorage();
    }

    saveToStorage() {
        const data = {
            quizResults: this.#quizResults,
            emailAddress: this.#emailAddress,
            firstName: this.#firstName,
            profile: this.#profile,
            utm: this.#utm,
        };
        this.#storage.setItem(this.#key, JSON.stringify(data));
    }

    loadFromStorage() {
        const data = this.getData();
        if (data) {
            if (
                this.#emailAddress === undefined ||
                this.#emailAddress === null ||
                this.#emailAddress === data.emailAddress
            ) {
                this.#data = data;
                this.#quizResults = data.quizResults;
                this.#emailAddress = data.emailAddress;
                this.#firstName = data.firstName;
            }
            this.#utm = data.utm;
            this.#profile = data.profile;
        }
    }

    getData() {
        const dataJSONString = this.#storage.getItem(this.#key);
        if (dataJSONString) {
            const data = JSON.parse(dataJSONString);
            return data;
        } else {
            return null;
        }
    }
}

class ZitamineCart extends ZitamineCommon {
    #cartWrapperElement = document.body;
    #storage = new ZitamineData("ZitamineQuiz", true);

    constructor(cartWrapperElement) {
        super();

        //clearcart();

        if (cartWrapperElement != undefined) {
            this.#cartWrapperElement = cartWrapperElement;
        }

        console.log(this.cartWrapperElement);
      
        this.render();
        this.initEventListeners();
    }

    initEventListeners() {
        const el = this.#cartWrapperElement;
      
        el.addEventListener("click", (e) => {
            const target = e.target;
            // // console.log(target.href);
            if (target.matches('[href="#remove-line-item"]')) {
                e.preventDefault();

                this.disableCartContents();
                const key = target.closest("[data-line-item-key]").dataset.lineItemKey;
                this.removeCartLineItem(key).then((json) => {
                    this.renderCartContents();
                });
            }
            if (target.matches('[href="#decrease-line-item-quantity"]')) {
                e.preventDefault();

                this.disableCartContents();
                const key = target.closest("[data-line-item-key]").dataset.lineItemKey;
                const qty =
                    parseInt(target.closest("[data-line-item-qty]").dataset.lineItemQty) -
                    1;
                this.setCartLineItemQty(key, qty).then((json) => {
                    this.renderCartContents();
                });
                loadSliderJs();
            }
            if (target.matches('[href="#increase-line-item-quantity"]')) {
                e.preventDefault();

                this.disableCartContents();
                const key = target.closest("[data-line-item-key]").dataset.lineItemKey;
                const qty =
                    parseInt(target.closest("[data-line-item-qty]").dataset.lineItemQty) +
                    1;
                this.setCartLineItemQty(key, qty).then((json) => {
                    this.renderCartContents();
                });
                loadSliderJs();
            }

            if (target.matches('[href="#add-to-cart"]')) {
                e.preventDefault();

                this.disableCartContents();
                const variantId =
                    target.closest("[data-variant-id]")?.dataset.variantId;
                const quantity = target.closest("[data-quantity]")?.dataset.quantity;
                const sellingPlan = target.closest("[data-selling-plan-id]")?.dataset
                    .sellingPlanId;
                // // console.log(variantId + ' ' + quantity + ' ' + sellingPlan);
                if (variantId) {
                    this.addToCart(variantId, quantity, sellingPlan).then((json) => {
                        this.renderCartContents();
                    });
                }
            }
        });
    }

    scrollToSection(sectionId) {
        const section = document.getElementById(sectionId);
        if (section) {
            window.scrollTo({
                top: section.offsetTop,
                behavior: "smooth",
            });
        }
    }
    render() {
        const el = this.#cartWrapperElement;
        const results = this.#storage.quizResults;
        setTimeout(() => {
            var storage = new ZitamineData("ZitamineQuiz", true);
            var firstName = storage.firstName;
            var count = 0;

            if (results) {
                if (results.RecommendationObjectivesDictionary) {
                    count = results.RecommendationObjectivesDictionary.length;
                }
            } else {
                var quiz = new ZitamineQuiz();
            }
        }, 1000);

        if (results) {
            el.querySelectorAll(
                "[data-zitamine-quiz-result-objective-template]"
            ).forEach((template) => {
                const parent = template.parentElement;
                parent.innerHTML = "";

                if (
                    results.HasHealthObjectives &&
                    results.RecommendationObjectivesDictionary?.length > 0
                ) {
                    for (const objective of results.RecommendationObjectivesDictionary) {
                        const templateClone = template.cloneNode(true);
                        parent.appendChild(templateClone);
                        this.fillObjectiveValues(templateClone, objective);
                    }
                }
            });

            el.querySelectorAll("[data-zitamine-quiz-result-month-template]").forEach(
                (template) => {
                    const parent = template.parentElement;
                    parent.innerHTML = "";

                    if (
                        results.MonthlyRecommendations &&
                        results.MonthlyRecommendations.length > 0
                    ) {
                        for (const month of results.MonthlyRecommendations) {
                            const templateClone = template.cloneNode(true);
                            parent.appendChild(templateClone);
                            this.fillMonthValues(templateClone, month);
                        }
                    }
                }
            );
        }

        this.fillDataValues("zitamine-quiz", el, this.#storage.getData());
        const cartContentsTemplateEl = el.querySelector(
            "[data-zitamine-quiz-result-cart-template]"
        );
        this.applyCartContentsData(cartContentsTemplateEl);
    }

    disableCartContents() {
        const el = this.#cartWrapperElement;
        el.querySelectorAll("[data-zitamine-quiz-result-cart-template]").forEach(
            (el) => {
                el.classList.add("disabled");

                el.style.pointerEvents = "none";
                el.style.opacity = ".5";
            }
        );
    }

    renderCartContents() {
        const el = this.#cartWrapperElement;
        this.disableCartContents();
        el.querySelectorAll("[data-zitamine-quiz-result-cart-template]").forEach(
            (el) => {
                const templateName = el.dataset.zitamineQuizResultCartTemplate;
                this.fetchCartContentsTemplate(templateName).then((templateHTML) => {
                    el.innerHTML = templateHTML;
                    this.enableCartContents();
                    this.applyCartContentsData(el);

                    updateTotal();

                });
            }
        );
    }

    applyCartContentsData(templateEl) {
        const el = this.#cartWrapperElement;

        const totalPrice = templateEl.querySelectorAll;
        const data = this.getDataFromTemplate(templateEl);
        this.fillDataValues("zitamine-quiz-cart-contents", el, data);
    }

    enableCartContents() {
        const el = this.#cartWrapperElement;
        el.querySelectorAll("[data-zitamine-quiz-result-cart-template]").forEach(
            (el) => {
                el.classList.remove("disabled");

                el.style.pointerEvents = null;
                el.style.opacity = null;
            }
        );
    }

    async shopifyCartChangeJs(request) {
        const response = await fetch("/cart/change.js", {
            headers: {
                "Content-Type": "application/json;charset=utf-8",
            },
            body: JSON.stringify(request),
            method: "POST",
        });

        const json = await response.json();
        window.cart_data.items = json.items;
    }

    async shopifyCartUpdateJs(request) {
        const response = await fetch(window.Shopify.routes.root + 'cart/update.js', {
            headers: {
                "Content-Type": "application/json;",
            },
            body: JSON.stringify({ updates: request }),
            method: "POST",
        });
        const json = await response.json();
        window.cart_data.items = json.items;

    }

    async removeCartLineItem(key) {
        // // console.log(key);
        const request = {
            id: key,
            quantity: 0,
        };
        return this.setCartLineItemQtyWithUpdate(key, 0);
        // return this.shopifyCartChangeJs(request);
    }

    async addToCart(variantId, quantity = 1, sellingPlan, properties) {
        // // console.log(variantId, quantity, sellingPlan);
        const item = {
            id: variantId,
            quantity: quantity,
        };
        if (sellingPlan !== undefined) {
            item.selling_plan = sellingPlan;
        }
        if (properties !== undefined) {
            item.properties = properties;
        }
        return this.shopifyCartAdd([item]);
    }

    async setCartLineItemQty(key, qty) {
        // // console.log(key, qty);
        const request = {
            id: key,
            quantity: qty,
        };

        return this.setCartLineItemQtyWithUpdate(key, qty);
        // return this.shopifyCartChangeJs(request);
    }

    async setCartLineItemQtyWithUpdate(key, qty) {
        const request = {};
        request[key] = qty;
        return this.shopifyCartUpdateJs(request);
    }

    async getProductHandleFromSKU(sku) {
        const productSKUTable = await this.fetchAllProductSKUTable();
      console.log("hello sku");
      console.log(productSKUTable);
      console.log(sku);
      if(sku != '000')
      {
         return productSKUTable[sku].handle;
      }
       
    }

    async getProductPriceFromSKU(sku) {
        // // console.log('price request ' + sku);
        const productSKUTable = await this.fetchAllProductSKUTable();
      if(sku != '000')
      {
        return productSKUTable[sku].price;
      }
        
    }

    async getProductHandleFromTitle(title) {
        const productTitleTable = await this.fetchAllProductTitleTable();
        return productTitleTable[title].handle;
    }

    async getProductTemplateFromTitle(title, templateName) {
        const productHandle = await this.getProductHandleFromTitle(title);
        const productTemplateHTML = await this.fetchProductTemplateHTML(
            productHandle,
            templateName
        );
        return productTemplateHTML;
    }

    async getProductTemplateFromSKU(sku, templateName) {
        const productHandle = await this.getProductHandleFromSKU(sku);
        const productTemplateHTML = await this.fetchProductTemplateHTML(
            productHandle,
            templateName
        );
        return productTemplateHTML;
    }

    async fetchProductTemplateHTML(productHandle, templateName) {
        const response = await fetch(
            `/products/${productHandle}?view=${templateName}`
        );
        const templateHTML = await response.text();
        return templateHTML;
    }

    async fetchCartContentsTemplate(templateName) {
        const response = await fetch(`/cart?view=${templateName}`);
        const templateHTML = await response.text();
        return templateHTML;
    }

    fillRecommendationValues(el, data) {
        const prefix = "zitamine-quiz-result-month-recommendation";

        // fill template
        this.fillDataValues(prefix, el, data);

        // load product template then fill
        this.processDataAttribute(el, `data-${prefix}-product-template`, (el) => {
            const datasetName = this.dataAttributeNameToDatasetPropertyName(
                `data-${prefix}-product-template`
            );
            const templateName = el.dataset[datasetName];
            /*this.getProductTemplateFromTitle(data.Name,templateName).then( templateHTML => {*/
            this.getProductTemplateFromSKU(data.ProductCode, templateName).then(
                (templateHTML) => {
                    // // console.log('getProductTemplateFromSKU');
                    // // console.log(el);
                    el.innerHTML = templateHTML;
                    this.fillDataValues(prefix, el, data);
                }
            );
        });
    }

    async computeRecommendationsTotalPrice(recommendations) {
        var totalPrice = 0;
        for (const recommendation of recommendations) {
            const price = await this.getProductPriceFromSKU(
                recommendation.ProductCode
            );
            const quantity = recommendation.Quantity;
            totalPrice += price * quantity;
        }
        return totalPrice;
    }

    fillMonthValues(el, data) {
        //compute price per day
        //// console.log(data);
        this.computeRecommendationsTotalPrice(data.Recommendations).then(
            (totalPrice) => {
                data.TotalPrice = totalPrice;
                this.fillDataValues("zitamine-quiz-result-month", el, data);
            }
        );

        el.querySelectorAll(
            "[data-zitamine-quiz-result-month-recommendation-template]"
        ).forEach((template) => {
            const parent = template.parentElement;
            parent.innerHTML = "";

            if (data.Recommendations.length > 0) {
                for (const recommendation of data.Recommendations) {
                    const templateClone = template.cloneNode(true);

                    parent.appendChild(templateClone);
                    this.fillRecommendationValues(templateClone, recommendation);
                }
            }
        });
    }

    fillObjectiveValues(el, data) {
        this.fillDataValues("zitamine-quiz-result-objective", el, data);
    }

    getDataFromTemplate(el) {
        const data = {};
        el.querySelectorAll("[data-name]").forEach((el) => {
            data[el.dataset.name] = el.innerHTML;
        });
        return data;
    }

    fillDataValues(prefix, el, data) {
        if (typeof data === "object") {
            for (const prop in data) {
                if (typeof data[prop] === "object" && data[prop] !== null) {
                    if (Array.isArray(data[prop])) {
                        this.fillDataValue(prefix, el, `${prop}-length`, data[prop].length);
                        this.fillDataValue(prefix, el, prop, data[prop].toString());
                        // // console.log('HANDLE: '+ this.handle(`${prop}-length`));
                    } else {
                        this.fillDataValue(prefix, el, prop, "object");
                    }
                } else {
                    this.fillDataValue(prefix, el, prop, data[prop]);
                }
            }
        } else {
            this.fillDataValue(prefix, el, "value", data);
        }
    }

    fillDataValue(prefix, el, prop, value) {
        //// console.log(`data-${prefix}-${this.handle(prop)}-inner-html = ${value}`);
        this.processDataAttribute(
            el,
            `data-${prefix}-${this.handle(prop)}-inner-html`,
            (el) => {
                el.innerHTML = value;
            }
        );
        this.processDataAttribute(
            el,
            `data-${prefix}-${this.handle(prop)}-inner-html-persist`,
            (el) => {
                el.innerHTML = value;
            },
            { removeAfter: false }
        );

        this.processDataAttribute(
            el,
            `data-${prefix}-${this.handle(prop)}-placeholder-attribute`,
            (el) => {
                el.setAttribute("placeholder", value);
            }
        );

        this.processDataAttribute(
            el,
            `data-${prefix}-${this.handle(prop)}-value-attribute`,
            (el) => {
                el.setAttribute("value", value);
            }
        );

        this.processDataAttribute(
            el,
            `data-${prefix}-${this.handle(prop)}-value`,
            (el) => { },
            { setValue: value }
        );
    }

    processDataAttribute(el, dataAttribute, callback, optionParams) {
        //// console.log(dataAttribute);
        if (dataAttribute == "data-zitamine-quiz-quiz-results-value") {
            //// console.log(dataAttribute);
            //// console.log(el);
        }

        const options = {
            removeAfter: true,
            setValue: undefined,
            ...optionParams,
        };
        const el2 = el;
        el.querySelectorAll(`[${dataAttribute}]`).forEach((el) => {
            callback(el);
            if (options.removeAfter || options.setValue !== undefined) {
                const datasetProperty =
                    this.dataAttributeNameToDatasetPropertyName(dataAttribute);
                if (options.removeAfter) {
                    if (!dataAttribute.endsWith("-persist"))
                        delete el.dataset[datasetProperty];
                }
                if (options.setValue !== undefined)
                    el.dataset[datasetProperty] = options.setValue;
            }
        });
    }
}

function clearcart() {
    jQuery.ajax({
        type: "POST",
        url: "/cart/clear.js",
        data: "",
        dataType: "json",
        success: function () {
            Shopify.clear();
        },
        error: function (XMLHttpRequest, textStatus) { },
    });
}

(function () {
  function init() {
    const b = document.body;
    if (b && b.matches(".template-cart")) {
      window.zqc = new ZitamineCart();
    }
  }
  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
})();
